module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_11.d9381c15.jpg";